import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

// used for form off of investment page.
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { investment: data } = await sdk.getOneInvestmentForPrivateQuartiles({
    id,
  });
  return { data };
}

export const investmentInvestmentPrivateQuartileGroupCategory = types.dataProvider({
  getOne,
});